import { render, staticRenderFns } from "./FaqsLanguageTab.vue?vue&type=template&id=47b398b9&"
import script from "./FaqsLanguageTab.vue?vue&type=script&lang=js&"
export * from "./FaqsLanguageTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports